import { render, staticRenderFns } from "./SingleProductEdit.vue?vue&type=template&id=79e650a8&scoped=true"
import script from "./SingleProductEdit.vue?vue&type=script&lang=js"
export * from "./SingleProductEdit.vue?vue&type=script&lang=js"
import style0 from "./SingleProductEdit.vue?vue&type=style&index=0&id=79e650a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e650a8",
  null
  
)

export default component.exports